import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Card, LockIcon, RadioFilledIcon, RadioIcon, SubscriptionIcon } from '@utilities';

import SubscriptionOverview from '../../../../../../../../components/SubscriptionOverview';

import styles from './_index.module.scss';

const PlanCard = ({ isSelected, onClick, subscription }) => {
  const remainingCompletes =
    (subscription && subscription?.monthlyCompletesTotal - subscription?.monthlyCompletesUsed) || 0;

  return (
    <Card
      className={classNames(styles['plan-card'], {
        [styles['is-disabled']]: remainingCompletes === 0,
        [styles['is-selected']]: isSelected,
      })}
      onClick={remainingCompletes === 0 ? undefined : onClick}
      padding="large"
    >
      <div className={styles['plan-card-content']}>
        <div className={styles['plan-card-title-row']}>
          {remainingCompletes === 0 ? (
            <span className={styles['plan-card-lock-icon']}>
              <LockIcon />
            </span>
          ) : (
            <span className={styles['plan-card-radio-icon']}>
              {isSelected ? <RadioFilledIcon /> : <RadioIcon />}
            </span>
          )}

          <h3 className={styles['plan-card-title']}>Use Your Plan</h3>
          <span className={styles['plan-card-icon']}>
            <SubscriptionIcon />
          </span>
        </div>
        <SubscriptionOverview />
      </div>
    </Card>
  );
};

PlanCard.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  subscription: PropTypes.shape({
    completesPerPeriod: PropTypes.number.isRequired,
    currentPeriod: PropTypes.shape({
      endDate: PropTypes.string.isRequired,
    }),
    monthlyCompletesTotal: PropTypes.number.isRequired,
    monthlyCompletesUsed: PropTypes.number.isRequired,
    monthlyEndDate: PropTypes.string.isRequired,
    periodEndDate: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default PlanCard;
